"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomepageContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//The HomePage context exposes various methods available to all children without passing them down through all props
var HomepageContext = exports.HomepageContext = /*#__PURE__*/_react["default"].createContext();